import { memo } from "react";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default memo(function LitcoLogo(props) {
  const { size, mobileSize, desktopSize, opacity } = props;

  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  return (
    <img
      src={process.env.PUBLIC_URL + "/images/Litco-Law-300.png"}
      height={size ? size : isMobile ? mobileSize : desktopSize}
      style={{ opacity: opacity }}
      alt="Litco Logo"
    />
  );
});
